// AIDEV-NOTE: Service cliente HTTP para visitas — com fallback offline via Dexie op_log

const API_BASE = '/api/v1/visitas';

async function apiFetch(url: string, options: RequestInit = {}) {
  const res = await fetch(url, { credentials: 'include', ...options });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error ?? `HTTP ${res.status}`);
  }
  return res.json();
}

export const visitaService = {
  async checkin(data: { cliente_id: string; lat: number; lng: number; accuracy?: number }) {
    const { data: visita } = await apiFetch(`${API_BASE}/checkin`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return visita;
  },

  async checkout(data: { visita_id: string; lat: number; lng: number; accuracy?: number }) {
    const { data: visita } = await apiFetch(`${API_BASE}/checkout`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return visita;
  },

  async atualizarFormulario(visitaId: string, formulario: Record<string, unknown>) {
    const { data } = await apiFetch(`${API_BASE}/${visitaId}/formulario`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formulario)
    });
    return data;
  },

  async listarVisitas(params: Record<string, string> = {}) {
    const qs = new URLSearchParams(params).toString();
    const { data } = await apiFetch(`${API_BASE}?${qs}`);
    return data;
  }
};
